import { IDatePickerStrings } from '@fluentui/react';

export function grabInitials(name: string): string {
  // empty string return
  if (!name || name.length === 0) {
    return '';
  }
  // grab first and last initial
  const nameArray = name.trim().split(' ');
  if (nameArray.length >= 2) {
    return nameArray[0][0] + nameArray[nameArray.length - 1][0];
  }
  // only a first name just return first initial
  return name[0];
}

function r4(): string {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

export function createGuid(): string {
  return r4() + r4() + '-' + r4() + '-' + r4() + '-' + r4() + '-' + r4() + r4() + r4();
}

export function startsWith(str: string, pre: string): boolean {
  return str.toLowerCase().indexOf(pre.toLowerCase()) === 0;
}

export function isNPIValid(npi?: string): boolean {
  if (!npi) {
    return false;
  }

  let sum = 0;
  let i = npi.length;
  if (i === 15 && npi.indexOf('80840', 0) === 0) {
    sum = 0;
  } else if (i === 10) {
    sum = 24;
  } else {
    return false;
  }
  let j = 0;
  while (i !== 0) {
    let temp = npi.charCodeAt(i - 1) - '0'.charCodeAt(0);
    if (j++ % 2 !== 0) {
      if ((temp <<= 1) > 9) {
        temp -= 10;
        temp++;
      }
    }
    sum += temp;
    i--;
  }
  return sum % 10 === 0;
}

// Convert string to URL/attribute-friendly slug
export function getSlug(text: string, separator = '-'): string {
  return text.toLowerCase().trim().replace(' ', separator);
}

export const DayPickerStrings: IDatePickerStrings = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  goToToday: 'Go to today',
  prevMonthAriaLabel: 'Go to previous month',
  nextMonthAriaLabel: 'Go to next month',
  prevYearAriaLabel: 'Go to previous year',
  nextYearAriaLabel: 'Go to next year',
  closeButtonAriaLabel: 'Close date picker',
};
